import * as actionTypes from '../actions/actionTypes';

const initialState = {
  showLoader: false,
};

const loaderReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SHOW_LOADER:
      return {
        ...state,
        showLoader:action.showLoader
      };
    case actionTypes.HIDE_LOADER:
      return {
        ...state,
        showLoader:action.showLoader
      };
    default:
      return {
        ...state,
      };
  }
};
export default loaderReducer;
